import { User } from 'lib-shared-types-api';
import { useEffect } from 'react';

import { MessageTyping } from './messageTyping';

interface Props {
  /** The authors. */
  authors: Record<string, User>;
  /** The typings. */
  typing: { csid: number; userId: string };
  /** Callback for whenever the components mounts. */
  onShow(): void;
}

/** Represents a typing indicator. */
export function Typing({ authors, typing, onShow }: Props): JSX.Element | null {
  const author = authors[typing.userId];

  useEffect(() => {
    onShow();
  }, []);

  return author ? <MessageTyping author={author} /> : null;
}
